/**
 * @desc 系统或浏览器信息
 * @author ruoxinhuang
 * @date 2021-09-09
 */
var ua = navigator.userAgent.toLowerCase();
/**
 * 获取安卓系统版本号
 * @returns
 */
function getAndroidVersion() {
    var version = null;
    if (ua.indexOf('android') > 0) {
        var reg = /android [\d._]+/gi;
        var vInfo = ua.match(reg);
        version = "".concat(vInfo).replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.'); // 得到版本号4.2.2
    }
    return version;
}
/**
 * 获取ios系统版本号
 * @returns
 */
function getIosVersion() {
    var version = null;
    if (ua.indexOf('like mac os x') > 0) {
        var reg = /os [\d._]+/gi;
        var vInfo = ua.match(reg);
        version = "".concat(vInfo).replace(/[^0-9|_.]/gi, '').replace(/_/gi, '.'); // 得到版本号9.3.2或者9.0
    }
    return version;
}
/**
 * app是否支持当前系统版本
 * 背景： ios最小支持到11，android支持到6
 * @returns
 */
function checkAppSupport() {
    var ua = window.navigator.userAgent || '';
    var minAndroidVersion = 6;
    var minIosVersion = 11;
    var isAndroid = /android/i.test(ua);
    var isIos = /iphone|ipad|ipod/i.test(ua);
    if (isIos) {
        var curVersion = getIosVersion();
        if (curVersion) {
            if (parseInt(curVersion.split('.')[0], 10) - minIosVersion < 0) {
                return false;
            }
            return true;
        }
    }
    else if (isAndroid) {
        var curVersion = getAndroidVersion();
        if (curVersion) {
            if (parseInt(curVersion.split('.')[0], 10) - minAndroidVersion < 0) {
                return false;
            }
            return true;
        }
    }
    return true;
}
var isFusionBankApp = /vb/i.test(ua);
var isAndroid = /android/i.test(ua);
var isIos = /iphone|ipad|ipod/i.test(ua);
var isWeChat = /micromessenger\/([\d.]+)/i.test(ua);
var isWeiBo = /(weibo).*weibo__([\d.]+)/i.test(ua);
var isQQ = /qq\/([\d.]+)/i.test(ua);
var isQQBrowser = /(qqbrowser)\/([\d.]+)/i.test(ua);
var isQZone = /qzone\/.*_qz_([\d.]+)/i.test(ua);
// 安卓 chrome 浏览器，很多 app 都是在 chrome 的 ua 上进行扩展的
var isOriginalChrome = /chrome\/[\d.]+ Mobile Safari\/[\d.]+/i.test(ua) && isAndroid;
// chrome for ios 和 safari 的区别仅仅是将 Version/<VersionNum> 替换成了 CriOS/<ChromeRevision>
// ios 上很多 app 都包含 safari 标识，但它们都是以自己的 app 标识开头，而不是 Mozilla
var isSafari = /safari\/([\d.]+)$/i.test(ua) && isIos && ua.indexOf('Crios') < 0 && ua.indexOf('Mozilla') === 0;
var osVersion = getIosVersion() || getAndroidVersion() || '';
var getWeChatVersion = function () {
    var weChatVersion = '';
    var weChatVersionMatch = ua.match(/MicroMessenger\/([\d\.]+)/i);
    if (weChatVersionMatch) {
        weChatVersion = weChatVersionMatch[0];
    }
    return weChatVersion;
};
var getModel = function () {
    // js获取不到手机的型号信息，
    var model = '';
    if (isAndroid) {
        model = 'android';
    }
    else if (isIos) {
        model = 'ios';
    }
    else {
        model = 'other';
    }
    var weChatVersion = getWeChatVersion();
    if (weChatVersion) {
        model = "".concat(model, "_").concat(weChatVersion);
    }
    if (ua.toLowerCase().indexOf('build') > 0) {
        var buildInfo = ua.match(/([^ ;]*)(\s)?build/i);
        if (buildInfo === null || buildInfo === void 0 ? void 0 : buildInfo[1]) {
            model = buildInfo[1];
        }
    }
    return model;
};
var appSupport = checkAppSupport();
var model = getModel();
export { isAndroid, isIos, isWeChat, isWeiBo, isQQ, isQQBrowser, isQZone, isOriginalChrome, isSafari, isFusionBankApp, osVersion, appSupport, model, };
